module.exports = __webpack_public_path__ + "img/fake-door-card.5d8bd30e.svg";